import React from 'react'
import { motion } from 'framer-motion';
import { FaCross, FaHeart, FaShare } from 'react-icons/fa';
import { useModal } from '../contexts/ModalContext';
import { RiCheckLine, RiCloseLine } from 'react-icons/ri';
import { CircularProgress, duration, TextField } from '@mui/material';
import useMunicipality from '../hooks/useMunicipality';
import useAuth from '../hooks/useAuth';
import { CheckBox, DisabledByDefault, Power, StarOutline } from '@mui/icons-material';
import { getSmartRecyclePoints, updateSmartRecycleDetails, updateUserDetails } from '../api';
import { MdElectricalServices, MdOutlineToggleOff, MdOutlineToggleOn } from 'react-icons/md';
import { useQuery } from 'react-query';

const ActionBoxBrown = ({ title, subtitle, icon, points, img, type, bottomTytle, buttonTitle, paddingLeft }) => {
    const { setModal, unSetModal, setWidth } = useModal()

    const { setModal: setErrorModal, unSetModal: unsetErrorModal } = useModal()

    var binNumber = 0;

    const { municipality } = useMunicipality();

    const { login, user, isAuthenticated, updateUserValues } = useAuth();

    const { isLoading, isError, data: recyclePoints, isFetched, isFetching } =
    useQuery('brown_bin_points', () => getSmartRecyclePoints(user !== null ? user.citizenId : null ), {
        refetchOnWindowFocus: false,
        refetchIntervalInBackground: false,       
    })

    //Error checking and loading        
    if (isLoading )
        return <div
            className='flex justify-center items-center h-screen'><CircularProgress></CircularProgress></div>

    if (isError )
        return <div
            className='flex p-8 justify-center h-screen items-center'>
            <div className=' text-center'>

                <p className='texgt-md font-medium'>ERROR LOADING DATA </p>
            </div>
        </div>

    return (
        <div className="container flex flex-col sm:w-5/6 md:w-5/6 lg:w-[40%] xl:w-[36.5%] ">

            <div className='flex items-center '>
                <img
                    src={icon}
                    alt={''}
                    className={`object-contain p-2  h-12 animate-waving-hand`}
                />
                <h3 className="text-3xl font-bold text-gray-700 ">{title}</h3></div>
            <h3 className="text-lg font-normal text-gray-700 pb-7">{subtitle}</h3>

            <motion.div
                initial={{ rotate: 25, scale: 0, opacity: 0 }}

                animate={{ rotate: 0, scale: 1, opacity: 1 }}
                transition={{
                    type: "spring",
                    stiffness: 260,
                    damping: 20
                }}
                className={` from-app_green to-app_green_light rounded-3xl mt-2 p-[5px] bg-gradient-to-r drop-shadow-2xl shadow-xl `}>
                <div className="relative justify-between flex flex-col  cursor-pointer rounded-3xl  bg-white">
                    <div className="absolute -top-6 flex items-center justify-center rounded-full  sm:w-[45%] h-12 left-1/2 transform -translate-x-1/2  bg-gray-100 border-[6px] drop-shadow-xl  border-white">
                        <div className='m-2 text-sm md:text-base font-semibold'>{type}</div>
                    </div>
                    <div className='p-8 h-96  flex justify-center text-center '>
                        <img
                            // src={'https://followgreen.fra1.digitaloceanspaces.com/Content/css/assets/recycle-coupon-yellow.svg'}
                            src={img}
                            alt={''}
                            className={`object-contain w-[75%] h-[100%] p-2 translate-y-5 ${paddingLeft ? 'mr-5' : ''}`}
                        />
                    </div >
                    <div className={`absolute -top-6 flex items-center justify-center bg-opacity-100 rounded-full shadow-md opacity-100 w-20 h-12 -right-3 bg-white`}
                        onClick={async () => {
                            if (!isAuthenticated) {
                                setModal(
                                    <div className='flex flex-col items-center justify-center py-5'>
                                        <motion.div
                                            initial={{ rotate: 500, scale: 0, opacity: 0 }}
                                            exit={{ rotate: 1, scale: 1, opacity: 0 }}

                                            animate={{ rotate: 0, scale: 1, opacity: 1 }}
                                            transition={{
                                                damping: 20,
                                                duration: 0.35
                                            }}
                                            className='border-4 border-app_red rounded-full w-20 h-20 flex justify-center items-center'>

                                            <div><RiCloseLine className='w-16 h-16 text-app_red'></RiCloseLine></div>
                                        </motion.div>
                                        <div className='font-bold text-lg text-center pt-5'>Κάνε εγγραφή ή συνδέσου για να κερδίσεις πόντους</div>
                                        <div className='flex justify-center cursor-pointer py-3 md:mx-2 mt-6 text-center text-white font-semibold hover:text-white bg-gradient-to-r p-[6px] from-app_green to-app_green_light  transition ease-in-out  rounded-xl md:w-[150px] hover:shadow-lg    hover:-translate-y-1 hover:scale-110 duration-150'
                                            onClick={() => { unSetModal() }}
                                        >OK</div>
                                    </div>
                                )
                            }

                            else {
                                var hasBrownBin = user.BrownBin;
                                if (hasBrownBin === 1) hasBrownBin = null;
                                else hasBrownBin = 1;
                                var recycleData = {
                                    Deh: user.Deh,
                                    ValidDeh: user.ValidDeh,
                                    BrownBin: hasBrownBin,
                                    BinNumber: user.BinNumber,
                                    RecyclableMaterials: user.RecyclableMaterials,
                                    PlasticBagNumber: user.PlasticBagNumber,
                                };
                                await updateSmartRecycleDetails({ citizenId: user.citizenId, data: recycleData })

                                updateUserValues();
                            }
                        }}
                    >
                     {!user ? <MdOutlineToggleOff className={`text-gray-300 h-14 w-14`}></MdOutlineToggleOff> :
                         <>
                         {!user.BrownBin ? <MdOutlineToggleOff className={`text-gray-300 h-14 w-14`}></MdOutlineToggleOff>
                               : <MdOutlineToggleOn className={`text-app_green  h-14 w-14`}></MdOutlineToggleOn>
                           }
                         </>
                     }
                    </div>



                    <div className="flex flex-col items-center text-center justify-evenly w-full ">

                        <div className="flex justify-center text-center w-11/12">
                            <p className="text-sm font-semibold text-gray-500 ">{bottomTytle}</p>
                        </div>

                        <div className='sm:flex '>

                            <div className="flex justify-center shadow-[inset_0px_6px_12px_rgba(0,0,0,0.3)] border-dashed border-[2px] border-gray-400  py-2 md:mx-4 w-32 sm:w-44 my-5 text-center bg-white rounded-xl md:w-[150px]">

                                <input placeholder={user === null ? '' :user.BinNumber}
                                    onChange={
                                        (e) => {

                                            e.persist()
                                            binNumber = e.target.value;
                                            console.log(binNumber)

                                        }
                                    }

                                    className="text-center font-semibold text-gray-900 w-32 bg-transparent"></input>

                            </div>
                            <div
                                className="flex justify-center  py-2 md:mx-2 my-5 text-center text-white font-semibold hover:text-white bg-gradient-to-r p-[6px] from-app_yellow  to-app_brown   transition ease-in-out  rounded-xl md:w-[150px] hover:shadow-lg  hover:shadow-orange-300  hover:-translate-y-1 hover:scale-110 duration-150"
                                onClick={async () => {
                                    if (!isAuthenticated) {
                                        setModal(
                                            <div className='flex flex-col items-center justify-center py-5'>
                                                <motion.div
                                                    initial={{ rotate: 500, scale: 0, opacity: 0 }}
                                                    exit={{ rotate: 1, scale: 1, opacity: 0 }}
                                                    animate={{ rotate: 0, scale: 1, opacity: 1 }}
                                                    transition={{
                                                        damping: 20,
                                                        duration: 0.35
                                                    }}
                                                    className='border-4 border-app_red rounded-full w-20 h-20 flex justify-center items-center'>

                                                    <div><RiCloseLine className='w-16 h-16 text-app_red'></RiCloseLine></div>
                                                </motion.div>
                                                <div className='font-bold text-lg text-center pt-5'>Κάνε εγγραφή ή συνδέσου για να κερδίσεις πόντους</div>


                                                <div className='flex justify-center cursor-pointer py-3 md:mx-2 mt-6 text-center text-white font-semibold hover:text-white bg-gradient-to-r p-[6px] from-app_green to-app_green_light  transition ease-in-out  rounded-xl md:w-[150px] hover:shadow-lg    hover:-translate-y-1 hover:scale-110 duration-150'
                                                    onClick={() => { unSetModal() }}
                                                >OK</div>
                                            </div>
                                        )
                                    }
                                    else {
                                        if (user.Deh === null) {
                                            var deh = 0;
                                            // setWidth(330)
                                            setModal(
                                                <div className='flex flex-col items-center justify-center py-5'>
                                                    <motion.div
                                                        initial={{ rotate: 500, scale: 0, opacity: 0 }}
                                                        exit={{ rotate: 1, scale: 1, opacity: 0 }}
                                                        animate={{ rotate: 0, scale: 1, opacity: 1 }}
                                                        transition={{
                                                            damping: 20,
                                                            duration: 0.35
                                                        }}
                                                        className='border-4 border-app_red rounded-full w-20 h-20 flex justify-center items-center'>

                                                        <div><MdElectricalServices className='w-16 h-16 text-app_red'></MdElectricalServices></div>
                                                    </motion.div>

                                                    <div className='font-bold text-lg text-center pt-5'>Καταχώρησε τον Αριθμό Παροχής Ηλεκτρικού Ρεύματος για να συνεχίσεις</div>

                                                    <p className=' text-center pt-5'>Από την ένδειξη "Αριθμός Παροχής" που αναγράφεται στον λογαριασμό σας: π.χ. 1 23456789-02 5 </p>
                                                    <p className='text-center text-md italic pt-1'>*Εισάγετε ΜΟΝΟ τα 8 ψηφία, που βρίσκονται μετά τον πρώτο αριθμό έως και την παύλα, όπως παρακάτω: 23456789
                                                    </p>


                                                    <TextField
                                                        className='!mt-5 !border-2 !outline-none !border-dashed !shadow-[inset_0px_6px_12px_rgba(0,0,0,0.3)]'
                                                        label=""
                                                        onChange={(e) => {

                                                            deh = e.target.value;
                                                        }}
                                                        type="number"
                                                        sx={{ padding: 0, borderRadius: '15px !important', }}

                                                    />
                                                    <div className='flex flex-col md:flex-row'>
                                                        <button className='flex justify-center cursor-pointer py-3 md:mx-2 mt-6 text-center text-white font-semibold hover:text-white bg-gradient-to-r p-[6px] from-app_green to-app_green_light  transition ease-in-out  rounded-xl md:w-[150px] hover:shadow-lg    hover:-translate-y-1 hover:scale-110 duration-150'
                                                            onClick={async () => {
                                                                const digits_only = string => [...string].every(c => '0123456789'.includes(c));
                                                                if (deh.length === 8 && digits_only(deh)) {
                                                                    console.log("Dei is: " + deh);

                                                                    var recycleData = {
                                                                        Deh: deh,
                                                                        ValidDeh: user.ValidDeh,
                                                                        BrownBin: user.BrownBin,
                                                                        BinNumber: user.BinNumber,
                                                                        RecyclableMaterials: user.RecyclableMaterials,
                                                                        PlasticBagNumber: user.PlasticBagNumber,
                                                                    };
                                                                    await updateSmartRecycleDetails({ citizenId: user.citizenId, data: recycleData })

                                                                    updateUserValues();

                                                                    unSetModal();

                                                                    setModal(
                                                                        <div className='flex flex-col items-center justify-center py-5'>
                                                                            <motion.div
                                                                                initial={{ rotate: 500, scale: 0, opacity: 0 }}
                                                                                exit={{ rotate: 1, scale: 1, opacity: 0 }}

                                                                                animate={{ rotate: 0, scale: 1, opacity: 1 }}
                                                                                transition={{
                                                                                    damping: 20,
                                                                                    duration: 0.35
                                                                                }}
                                                                                className='border-4 border-app_green_light rounded-full w-20 h-20 flex justify-center items-center'>

                                                                                <div><RiCheckLine className='w-16 h-16 text-app_green_light'></RiCheckLine></div>
                                                                            </motion.div>
                                                                            <div className='font-bold text-lg text-center pt-5'>Ο αριθμός παροχής καταχωρήθηκε επιτυχώς!</div>
                                                                            <div className='flex justify-center cursor-pointer py-3 md:mx-2 mt-6 text-center text-white font-semibold hover:text-white bg-gradient-to-r p-[6px] from-app_green to-app_green_light  transition ease-in-out  rounded-xl md:w-[150px] hover:shadow-lg    hover:-translate-y-1 hover:scale-110 duration-150'
                                                                                onClick={() => { unSetModal() }}
                                                                            >OK</div>
                                                                        </div>
                                                                    )


                                                                }
                                                                else {
                                                                    setErrorModal(
                                                                        <div className='flex flex-col items-center justify-center py-5'>
                                                                            <motion.div
                                                                                initial={{ rotate: 500, scale: 0, opacity: 0 }}
                                                                                exit={{ rotate: 1, scale: 1, opacity: 0 }}

                                                                                animate={{ rotate: 0, scale: 1, opacity: 1 }}
                                                                                transition={{
                                                                                    damping: 20,
                                                                                    duration: 0.35
                                                                                }}
                                                                                className='border-4 border-app_red rounded-full w-20 h-20 flex justify-center items-center'>

                                                                                <div><RiCloseLine className='w-16 h-16 text-app_red'></RiCloseLine></div>
                                                                            </motion.div>
                                                                            <div className='font-bold text-lg text-center pt-5'>Ο Αριθμός Παροχής δεν είναι σωστός
                                                                            </div>
                                                                            <div className='flex justify-center cursor-pointer py-3 md:mx-2 mt-6 text-center text-white font-semibold hover:text-white bg-gradient-to-r p-[6px] from-app_green to-app_green_light  transition ease-in-out  rounded-xl md:w-[150px] hover:shadow-lg    hover:-translate-y-1 hover:scale-110 duration-150'
                                                                                onClick={() => { unsetErrorModal() }}
                                                                            >OK</div>
                                                                        </div>
                                                                    )
                                                                }
                                                            }}
                                                        >Καταχώρηση</button>


                                                        <div className='flex justify-center cursor-pointer py-3 md:mx-2 mt-6 text-center text-white font-semibold hover:text-white bg-gradient-to-r p-[6px] from-app_red to-app_brown  transition ease-in-out  rounded-xl md:w-[150px] hover:shadow-lg    hover:-translate-y-1 hover:scale-110 duration-150'
                                                            onClick={() => { unSetModal() }}
                                                        >Ακύρωση</div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        else {

                                            if (binNumber > 1) {
                                                var recycleData = {
                                                    Deh: user.Deh,
                                                    ValidDeh: user.ValidDeh,
                                                    BrownBin: user.BrownBin,
                                                    BinNumber: binNumber,
                                                    RecyclableMaterials: user.RecyclableMaterials,
                                                    PlasticBagNumber: user.PlasticBagNumber,
                                                };
                                                const dataChangeResponce = await updateSmartRecycleDetails({ citizenId: user.citizenId, data: recycleData })

                                                console.log(dataChangeResponce)
                                                if (dataChangeResponce.status === 2) {
                                                    setErrorModal(
                                                        <div className='flex flex-col items-center justify-center py-5'>
                                                            <motion.div
                                                                initial={{ rotate: 500, scale: 0, opacity: 0 }}
                                                                exit={{ rotate: 1, scale: 1, opacity: 0 }}

                                                                animate={{ rotate: 0, scale: 1, opacity: 1 }}
                                                                transition={{
                                                                    damping: 20,
                                                                    duration: 0.35
                                                                }}
                                                                className='border-4 border-app_red rounded-full w-20 h-20 flex justify-center items-center'>

                                                                <div><RiCloseLine className='w-16 h-16 text-app_red'></RiCloseLine></div>
                                                            </motion.div>
                                                            <div className='font-bold text-lg text-center pt-5'>Έχετε ήδη αλλάξει (2) φορές αριθμό ετικέτας κάδου
                                                            </div>
                                                            <div className='flex justify-center cursor-pointer py-3 md:mx-2 mt-6 text-center text-white font-semibold hover:text-white bg-gradient-to-r p-[6px] from-app_green to-app_green_light  transition ease-in-out  rounded-xl md:w-[150px] hover:shadow-lg    hover:-translate-y-1 hover:scale-110 duration-150'
                                                                onClick={() => { unsetErrorModal() }}
                                                            >OK</div>
                                                        </div>
                                                    )
                                                }
                                                else {
                                                    updateUserValues();
                                                    setModal(
                                                        <div className='flex flex-col items-center justify-center py-5'>
                                                            <motion.div
                                                                initial={{ rotate: 500, scale: 0, opacity: 0 }}
                                                                exit={{ rotate: 1, scale: 1, opacity: 0 }}

                                                                animate={{ rotate: 0, scale: 1, opacity: 1 }}
                                                                transition={{
                                                                    damping: 20,
                                                                    duration: 0.35
                                                                }}
                                                                className='border-4 border-app_green_light rounded-full w-20 h-20 flex justify-center items-center'>

                                                                <div><RiCheckLine className='w-16 h-16 text-app_green_light'></RiCheckLine></div>
                                                            </motion.div>
                                                            <div className='font-bold text-lg text-center pt-5'>Συγχαρητήρια! Τα στοιχεία σου καταχωρήθηκαν με επιτυχία και επεξεργάζονται άμεσα από την ομάδα μας.</div>
                                                            <div className='flex justify-center cursor-pointer py-3 md:mx-2 mt-6 text-center text-white font-semibold hover:text-white bg-gradient-to-r p-[6px] from-app_green to-app_green_light  transition ease-in-out  rounded-xl md:w-[150px] hover:shadow-lg    hover:-translate-y-1 hover:scale-110 duration-150'
                                                                onClick={() => { unSetModal() }}
                                                            >OK</div>
                                                        </div>
                                                    )
                                                }
                                            }

                                        }
                                    }
                                }}
                            >

                                {buttonTitle}

                            </div>


                        </div>

                        <div className='flex items-center  bg-app_green rounded-3xl m-2 text-white  p-1'>
                            <div className='flex font-lg my-2 ml-1 h-18 w-18 bg-white rounded-full text-app_green p-1'>
                                <StarOutline  ></StarOutline>
                            </div>
                            <div className='text-sm py-2 pr-2 text-left pl-2'>
                                Έως σήμερα έχεις κερδίσει: {recyclePoints.brownBinPoints} πόντους από την ανακύκλωση
                            </div>
                        </div>

                        <div className='px-5 pb-5 text-sm text-left'>Ο κωδικός της μεταλλικής ετικέτας π.χ. 0001 αναγράφεται στην
                            πίσω πλευρά του καφέ κάδου που εξυπηρετεί το κτίριό σου.
                            Προσοχή! Ο κωδικός ετικέτας δεν ταυτίζεται με τον αριθμό στο
                            καπάκι του καφέ κάδου κτιρίου.
                        </div>


                    </div>
                </div>
            </motion.div>
        </  div>
    )
}

export default ActionBoxBrown